import ListItem from '@mui/material/ListItem';
import { type FC, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { type ListChildComponentProps } from 'react-window';

import EventNotification from './EventNotification.js';
import { useEndEvent } from '../../api/index.js';
import { useCheckPermissions } from '../../auth/index.js';
import { type Event, EventCategory } from '../../models/index.js';

const EventsListItem: FC<ListChildComponentProps> = ({ data, index, style }) => {
  const { canReadPatient } = useCheckPermissions();
  const endEvent = useEndEvent();
  const navigate = useNavigate();

  const onClick = useCallback(
    async (event: Event) => {
      const { category } = event;

      if (canReadPatient) {
        navigate(`/patients/${event.patientId}`);
      }

      // For certain events, we will end the event when it's clicked
      if (category === EventCategory.MOTION || category === EventCategory.WELLNESS_CHECK) {
        await endEvent.mutateAsync(event.id);
      }
    },
    [canReadPatient],
  );

  return (
    <ListItem style={style} key={index} component="div" disablePadding>
      <EventNotification event={data[index]} shouldShowTime onClick={onClick} />
    </ListItem>
  );
};

export default EventsListItem;
